import gql from 'graphql-tag';

const UPDATE_FAVORITE_LEADS = gql`
  mutation UpdateFavoriteLeads($params: UpdateFavoriteLeadsParams!) {
    updateFavoriteLeads(params: $params)
  }
`;

export default UPDATE_FAVORITE_LEADS;
